import { useCallback, useState } from 'react';
import { useQuery } from '@common-fe/common-fe';
import _ from 'lodash';

import { api } from '@/api';
import { ALL_OPTION_KEY } from '@/common/constants';
import { API_URL } from '@/dtos';

import { useDownloadCSV, useGetEmployerIdParam } from '../../hooks';
import { ClaimsActivitySummaryReportParams } from '../ClaimsActivityReport.types';

export const QUERY_KEY = 'EXPORT_CLAIMS_ACTIVITY_REPORT_CSV';
const useClaimsActivityReportExportSummaryCSVQuery = (params: ClaimsActivitySummaryReportParams) => {
  const handleSaveFile = useDownloadCSV();
  const [isLoading, setIsLoading] = useState(false);
  const getEmployerIdParam = useGetEmployerIdParam();
  const { refetch } = useQuery(
    [QUERY_KEY],
    () =>
      api.get(
        params.isMultipleEmployer
          ? API_URL.REPORTS_CLAIM_ACTIVITY_REPORT_MULTI_EMPLOYERS_SUMMARY_EXPORT_CSV
          : API_URL.REPORTS_CLAIM_ACTIVITY_REPORT_SUMMARY_EXPORT_CSV,
        {
          params: _.pickBy({
            ...getEmployerIdParam(params.employerId, params.employerIds),
            claim_statuses:
              params?.claimStatuses && !params?.claimStatuses.includes(ALL_OPTION_KEY)
                ? params?.claimStatuses.join(',')
                : undefined,
            claim_types:
              params?.claimTypes && !params?.claimTypes.includes(ALL_OPTION_KEY)
                ? params?.claimTypes.join(',')
                : undefined,
          }),
        }
      ),
    {
      retry: 0,
      enabled: false,
    }
  );

  const handleExport = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await refetch();
      handleSaveFile(response.data?.data, 'csv', 'claims_activity_summary');
    } finally {
      setIsLoading(false);
    }
  }, [handleSaveFile, refetch]);
  return {
    isLoading,
    handleExport,
  };
};

export default useClaimsActivityReportExportSummaryCSVQuery;
